module.exports = __webpack_public_path__ + "static/media/muli-latin-600italic.7567e136.woff2";